import { Routes, RouterModule } from '@angular/router';

import { AdminScreenComponent } from './admin.component';

const adminRoutes: Routes = [
];

export const AdminRouter = RouterModule.forChild(adminRoutes);